export default [
    {
        path: '/',
        name: 'Eligibility-Finance',
        redirect: '/eligibility-finance'
    },
    {
        path: '/eligibility-finance',
        name: 'Eligibility-Finance-Module',
        component: () => import('@/views/modules/eligibility_finance/finance.vue')
    },
    {
        path: '/form-contact',
        name: 'Finance-Form-Contact',
        component: () => import('@/views/modules/eligibility_finance/forms/_contact.vue')
    },
    {
        path: '/form-otp',
        name: 'Finance-Form-Otp',
        component: () => import('@/views/modules/eligibility_finance/forms/_otp.vue')
    },
    {
        path: '/form-success',
        name: 'Finance-Form-Success',
        component: () => import('@/views/modules/eligibility_finance/forms/_success.vue')
    },
    {
        path: '/eligible-check',
        name: 'Finance-Eligible-Check',
        component: () => import('@/views/modules/eligibility_finance/forms/_eligible.vue')
    },
    {
        path: '/eligible-result',
        name: 'Finance-Eligible-Result',
        component: () => import('@/views/modules/eligibility_finance/_result.vue')
    },
];